import styled from "styled-components";
import { Link } from "react-router-dom";
import breakpoints from "../../../styles/breakpoints";
import { colors, fonts } from "../../../styles/variables";
import gpdUmbrella from "../../../assets/images/general/black-umbrella.png";

export const TastebudProfileContainer = styled.div<{
  isWineDetailsPage: boolean;
}>`
  width: 100%;
  background-color: ${colors.peach};
  padding: ${(props) => (props.isWineDetailsPage ? "40px 80px" : "32px 15px")};
  min-height: 600px;
  ${breakpoints.smDown} {
    padding: 32px 15px;
  }
`;

export const TastebudContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  margin-bottom: 16px;
`;

export const TasteProfileTitle = styled.div`
  font-size: 18px;
  line-height: 24px;
  margin-bottom: 24px;
  font-family: ${fonts.fontBauMedium};
  text-transform: uppercase;
  ${breakpoints.smDown} {
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 16px;
  }
`;

export const TastingNotes = styled.div`
  font-size: 18px;
  line-height: 25px;
  margin-bottom: 24px;
  font-family: ${fonts.fontBauRegular};
  ${breakpoints.smDown} {
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 16px;
  }
`;

export const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  justify-content: center;
`;

export const ButtonRow = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 24px;
  ${breakpoints.smDown} {
    margin-bottom: 16px;
  }
`;

export const TasteProfileButton = styled.button<{
  color: string;
  isSelected: boolean;
}>`
  font-size: 10px;
  line-height: 14px;
  font-family: ${fonts.fontBauMedium};
  padding: 8px 13px;
  border: 2px solid ${(props) => props.color};
  background-color: ${(props) => (props.isSelected ? props.color : "")};
  text-transform: uppercase;
  margin-right: 12px;
  color: ${colors.black};
`;

export const TastebudLabelContainer = styled(RowContainer)`
  max-width: 95px;
  min-width: 95px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
`;

export const RadioIconsContainer = styled.div<{ width: number }>`
  width: 100%;
  align-items: center;
  justify-content: space-between;
  position: relative;
  display: flex;
  flex-direction: column;
`;

export const FloatingLevelsBar = styled.div`
  height: 25px;
  border-radius: 12.5px;
  width: 100%;
  background-color: ${colors.white};
  position: relative;
  z-index: 1;
`;

export const VerticalWhiteLine = styled.div`
  position: absolute;
  height: 25px;
  width: 2px;
  background-color: ${colors.peach};
  left: 50%;
  top: 0;
  z-index: 2;
`;

export const TextLabelContainer = styled(RowContainer)`
  justify-content: space-between;
  width: 100%;
`;

export const TextLabel = styled.span`
  margin-top: 8px;
  display: inline-block;
  flex: 1;
  min-width: 48px;
  text-align: center;
  &:first-child {
    text-align: left;
  }
  &:last-child {
    text-align: right;
  }
  ${breakpoints.xsDown} {
    white-space: pre-line;
  }
`;

export const RadioIconContainer = styled.div<{
  radioIconWidth?: number;
  bgColor?: string;
  leftPosition?: number;
  isRatingIcon?: boolean;
}>`
  min-height: ${(props) => props.radioIconWidth || 25}px;
  min-width: ${(props) => props.radioIconWidth || 25}px;
  border-radius: 12.5px;
  border-width: 1.5px;
  background-color: ${(props) => props.bgColor || colors.coral};
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  z-index: ${(props) => (props.isRatingIcon ? 3 : 4)};
  left: ${(props) => props.leftPosition ?? 0}px;
`;

export const RadioIcon = styled.img`
  width: 12px;
  height: 10px;
`;

export const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 80px 0px;
`;

export const UmbrellaImage = styled.img.attrs(() => ({ src: gpdUmbrella }))`
  width: 90px;
  height: 67px;
  margin-bottom: 24px;
`;

export const UnlockTitle = styled.div`
  font-size: 25px;
  line-height: 27px;
  font-family: ${fonts.fontInterstateBlackCompressed};
  margin-bottom: 12px;
`;

export const EmptyStateText = styled(TastingNotes)<{
  centerAlignText?: boolean;
}>`
  text-align: ${(props) => (props.centerAlignText ? "center" : "")};
  margin-bottom: 16px;
`;

export const Gradient = styled.div<{
  isWineRadioLeftOfRatingRadio: boolean;
  ratingRadioPosition: number;
  wineRadioPosition: number;
}>`
  position: absolute;
  left: ${(props) =>
    props.isWineRadioLeftOfRatingRadio ? props.wineRadioPosition + 12.5 : props.ratingRadioPosition + 12.5}px;
  width: ${(props) =>
    props.isWineRadioLeftOfRatingRadio
      ? props.ratingRadioPosition - props.wineRadioPosition
      : props.wineRadioPosition - props.ratingRadioPosition}px;
  background: ${(props) =>
    props.isWineRadioLeftOfRatingRadio
      ? `linear-gradient(90deg, ${colors.coralGradient} 0%, ${colors.blueTint} 100%)`
      : `linear-gradient(90deg, ${colors.blueTint} 0%, ${colors.coralGradient} 100%)`};
  height: 25px;
  z-index: 2;
`;

export const StyledLink = styled(Link)`
  text-decoration: underline;
  &:hover {
    text-decoration: underline;
  }
  &:focus {
    text-decoration: underline;
  }
`;
